<script>
    import Icon from 'svelte-awesome';
    import { times } from 'svelte-awesome/icons';

    export let show = false;
    export let global = false;
    export let contrast = false;

</script>

{#if show}
    <span class="overlay-close-button" class:global class:contrast on:click>
        <Icon scale="3" data={times} />
    </span>
{/if}

<style>
    .overlay-close-button {
        position: absolute;
        top: 25px;
        right: 50px;
        color: white;
        cursor: pointer;
    }

    .overlay-close-button.global {
        position: fixed;
        top: 25px;
        right: 50px;
    }

    .overlay-close-button.contrast {
        color: #666;
    }
</style>